import React from 'react'

const FavoritesPage: React.FC = () => {
    

    return (
        <></>
    )
}

export default FavoritesPage